module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('uikit:simple-page', {
    attrs: {
      "no-header": ""
    }
  }, [_c('government', {
    attrs: {
      "president": _vm.president,
      "chancellor": _vm.chancellor
    }
  }), (_vm.localPlayer.hasVoted) ? _c('player-list', {
    attrs: {
      "large": "",
      "filter": _vm.filter
    }
  }, [_c('v-list-tile', {
    attrs: {
      "slot": "prefix"
    },
    slot: "prefix"
  }, [_c('v-list-tile-action', [_c('v-icon', {
    staticClass: "icon",
    attrs: {
      "medium": ""
    }
  }, [_vm._v("hourglass_empty")])], 1), _c('v-list-tile-title', [_c('span', {
    staticClass: "header"
  }, [_vm._v("Waiting for votes...")])])], 1)], 1) : _c('v-layout', {
    staticClass: "pl-3",
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, _vm._l(([true, false]), function(val) {
    return _c('v-flex', {
      key: val,
      staticClass: "card-box"
    }, [_c('voting-card', {
      staticClass: "mr-3",
      class: {
        active: _vm.vote === val
      },
      attrs: {
        "vote": val
      },
      on: {
        "input": function($event) {
          _vm.vote = val
        }
      }
    })], 1)
  })), _c('v-layout', {
    attrs: {
      "slot": "footer",
      "align-center": "",
      "justify-center": ""
    },
    slot: "footer"
  }, [(!_vm.localPlayer.hasVoted) ? _c('v-btn', {
    attrs: {
      "disabled": typeof _vm.vote != 'boolean'
    },
    on: {
      "click": function($event) {
        _vm.submit()
      }
    }
  }, [_vm._v("Vote")]) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ced4132","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src.player/ui/game-states/VOTING/index.vue
// module id = 327
// module chunks = 0